import { Navigate, Outlet, useLocation } from 'react-router';
import { Loading } from '../../shared/ui/components';
import { useSession } from './SessionProvider';

/** Protege las rutas de /app: sin sesión, envía a /entrar y vuelve después. */
export function RequireSession() {
  const { state } = useSession();
  const location = useLocation();
  if (state.status === 'loading') return <Loading label="Abriendo KEORA…" />;
  if (state.status === 'anonymous') {
    return <Navigate to={`/entrar?volver=${encodeURIComponent(location.pathname)}`} replace />;
  }
  return <Outlet />;
}
